module.exports = __webpack_public_path__ + "static/media/Icon awesome-plus.558412f8.svg";